// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscribe-paid-membership-plan .form-section{margin-bottom:1rem}.subscribe-paid-membership-plan .form-content{padding:10px 15px}.subscribe-paid-membership-plan .coupon-code__form{padding-bottom:10px;display:flex}.subscribe-paid-membership-plan .coupon-code__title,.subscribe-paid-membership-plan .masked-number{font-size:1rem}.subscribe-paid-membership-plan .coupon-code__input{margin-right:.5em}.subscribe-paid-membership-plan .icon-check{color:green}", ""]);
// Exports
module.exports = exports;
